function isMultipleInstance(attribute) {
    var _a;
    return ((_a = attribute.cardinalityMax) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) > 1;
}
/**
 * Helper function to determine if the index should be shown in the substructure label
 * @param attribute
 * @returns
 */
export function shouldShowIndexInSubstructure(attribute) {
    return isMultipleInstance(attribute);
}
//# sourceMappingURL=shouldShowIndexInSubstructure.js.map